<template>

    <Page>

        <ImageAndText 
            src="/Challenge/goodwill.png"
            animation="slide-up"
            border
            image-class="rounded-xl"
            floor-shadow
            :flip="true">

            <h2 class="mb-4">Your goodwill is your leverage - protect it</h2>
            <p class="font-normal text-white/80 mb-4">
                All industry stakeholders are competing fiercely for 
                consumer ownership, leading to significant erosion of
                goodwill value.
            </p>
            <p class="font-normal text-white/80">
                The dealership is not always the consumers' first thought
                for minor repair work and maintenance.
            </p>

        </ImageAndText>

    </Page>

</template>